import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_REGISTRATION } from './url-constants';

type SiteRegistrationsEndpointSpecification = ApiEndpointSpecification;
export const SiteRegistrationsEndpointSpecification: SiteRegistrationsEndpointSpecification = {
    url: SITE_REGISTRATION,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SiteRegistrationRequestParams',
    requestBodySchemaName: 'SiteRegistrationRequestBody',
    okResponseSchemaName: 'SiteRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteRegistration = Helpers.makeApiRequestFn<
    Types.SiteRegistrationRequestParams,
    Types.SiteRegistrationRequestBody,
    Types.SiteRegistrationOkResponse
>(SiteRegistrationsEndpointSpecification);
